import { PrismicNextImage } from '@prismicio/next';
import { FC } from 'react';
import { SimpleCaseStudySliceChallengeAndSolution } from '../../../../prismicio-types';

interface ChangeAndSolutionProps {
  slice: SimpleCaseStudySliceChallengeAndSolution;
}

const ChallengeAndSolution: FC<ChangeAndSolutionProps> = (props) => {
  const {
    title,
    industry,
    challenge: challengeText,
    solution: solutionText,
  } = props.slice.primary;
  const {
    imagereference: referenceImage,
    teamrole: teamInvolved,
    techstack: techStack,
  } = props.slice.primary;

  return (
    <div className="bg-gradient-to-b from-[#0F3932] to-[#0E1110] text-white font-inter pt-64">
      <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-[60px] px-6">
        <div className="flex flex-col col-span-4 md:col-span-3 gap-[60px]">
          <div className="flex flex-col gap-6">
            <h2 className="text-[40px] font-semibold">The Challenge</h2>
            <p className="font-normal leading-[150%] text-lg">
              {challengeText}
            </p>
          </div>
          <div className="flex flex-col gap-6">
            <h2 className="text-[40px] font-semibold">The Solution</h2>
            <p className="font-normal leading-[150%] text-lg">{solutionText}</p>
            <PrismicNextImage
              field={referenceImage}
              className="w-full object-contain"
            />
          </div>
        </div>
        <div className="col-span-4 md:col-span-1">
          <div className="font-manrope flex flex-col gap-6 bg-gradient-radial from-[#0F393280] to-[#03BF9E80] p-6 rounded-[24px]">
            <div className="flex flex-col gap-2">
              <div className="font-bold text-xl leading-[140%]">Client</div>
              <div className="font-normal text-lg leading-[150%]">{title}</div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold text-xl leading-[140%]">Industry</div>
              <div className="font-normal text-lg leading-[150%]">
                {industry}
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold text-xl leading-[140%]">
                Team Involved
              </div>
              <div className="font-normal text-lg leading-[150%]">
                {teamInvolved.map((member, index) => (
                  <>
                    <span key={index}>{member.role}</span>{' '}
                    {index !== 0 && <br />}
                  </>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold text-xl leading-[140%]">Tech Stack</div>
              <div className="flex flex-col gap-2 items-start">
                {techStack.map((tech, index) => (
                  <figure key={index}>
                    <PrismicNextImage field={tech.icon} className="w-24 h-8" />
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeAndSolution;
